import * as React from "react"
import { Outlet, createFileRoute, useNavigate } from "@tanstack/react-router"

import { useAbility, useAbilityReady } from "@/lib/ability"

export const Route = createFileRoute("/_app/admin")({
  component: AdminLayout,
})

/**
 * The admin area. Guidance only, like the login check one level up: every
 * endpoint behind these pages checks `Administration` or its own subject.
 */
function AdminLayout() {
  const ability = useAbility()
  const ready = useAbilityReady()
  const navigate = useNavigate()
  const allowed = ability.can("read", "Administration")

  React.useEffect(() => {
    if (ready && !allowed) void navigate({ to: "/", replace: true })
  }, [ready, allowed, navigate])

  if (!ready || !allowed) return null
  return <Outlet />
}
